"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var GoldCounterProvider_1 = require("./GoldCounterProvider");
var PurchaseTrophiesDialog_1 = __importDefault(require("./PurchaseTrophiesDialog"));
var PurchaseTrophyDialog_1 = __importDefault(require("./PurchaseTrophyDialog"));
var PurchaseTrophiesDialogContainer = function () {
    var _a = GoldCounterProvider_1.useGoldCounter(), value = _a.value, trophiesDialogOpen = _a.trophiesDialogOpen, closeTrophiesDialog = _a.closeTrophiesDialog, purchaseTrophyDialogOpen = _a.purchaseTrophyDialogOpen, closePurchaseTrophyDialog = _a.closePurchaseTrophyDialog, selectPurchaseTrophy = _a.selectPurchaseTrophy, openPurchaseTrophyDialog = _a.openPurchaseTrophyDialog, purchaseTrophyId = _a.purchaseTrophyId, purchaseTrophy = _a.purchaseTrophy, purchasedTrophies = _a.purchasedTrophies;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(PurchaseTrophiesDialog_1.default, { open: trophiesDialogOpen, onClose: closeTrophiesDialog, onClickClose: closeTrophiesDialog, onClickTrophy: function (trophyId) {
                selectPurchaseTrophy(trophyId);
                openPurchaseTrophyDialog();
            }, availableGold: value, purchasedTrophies: purchasedTrophies }),
        react_1.default.createElement(PurchaseTrophyDialog_1.default, { trophy: purchaseTrophyId, open: purchaseTrophyDialogOpen, onClose: closePurchaseTrophyDialog, onClickClose: closePurchaseTrophyDialog, onClickBuy: purchaseTrophy, availableGold: value, hasPurchased: purchasedTrophies.includes(purchaseTrophyId) })));
};
exports.default = PurchaseTrophiesDialogContainer;
//# sourceMappingURL=PurchaseTrophiesDialogContainer.js.map